import { render, staticRenderFns } from "./product-history.vue?vue&type=template&id=cc802e5a&scoped=true&"
import script from "./product-history.vue?vue&type=script&lang=ts&"
export * from "./product-history.vue?vue&type=script&lang=ts&"
import style0 from "./product-history.vue?vue&type=style&index=0&id=cc802e5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc802e5a",
  null
  
)

export default component.exports